import { switchClasses } from '@mui/material/Switch';
var SWITCH_DIMENSIONS = {
    heightPx: 24,
    widthPx: 44,
    thumbSizePx: 16,
};
export var createMuiSwitchOverrides = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var typography = _a.typography, tokens = _a.tokens, mixins = _a.mixins;
    return {
        defaultProps: {
            color: 'primary',
            size: 'medium',
        },
        styleOverrides: {
            root: {
                width: typography.pxToRem(SWITCH_DIMENSIONS.widthPx),
                height: typography.pxToRem(SWITCH_DIMENSIONS.heightPx),
                padding: 0,
                overflow: 'visible',
                '&:focus-within,&.Mui-focused': (_b = {},
                    _b["& .".concat(switchClasses.track)] = mixins.focusRing(),
                    _b),
            },
            colorPrimary: (_c = {
                    color: tokens.color_bg_layer
                },
                _c["&.".concat(switchClasses.checked)] = (_d = {
                        color: tokens.color_bg_layer
                    },
                    _d["& + .".concat(switchClasses.track)] = {
                        backgroundColor: tokens.color_bg_switch_on,
                    },
                    _d["&.".concat(switchClasses.disabled)] = (_e = {
                            color: tokens.color_bg_layer
                        },
                        _e["& + .".concat(switchClasses.track)] = {
                            backgroundColor: tokens.color_bg_switch_on_disabled,
                        },
                        _e),
                    _d),
                _c["&.".concat(switchClasses.disabled)] = (_f = {
                        color: tokens.color_bg_layer
                    },
                    _f["& + .".concat(switchClasses.track)] = {
                        opacity: 1,
                        backgroundColor: tokens.color_bg_disabled,
                    },
                    _f),
                _c),
            track: {
                opacity: 1,
                backgroundColor: tokens.color_bg_layer_bold,
                borderRadius: typography.pxToRem(SWITCH_DIMENSIONS.heightPx * 2),
            },
            switchBase: (_g = {
                    borderRadius: '50%',
                    padding: typography.pxToRem((SWITCH_DIMENSIONS.heightPx - SWITCH_DIMENSIONS.thumbSizePx) / 2),
                    height: 'unset',
                    width: 'unset'
                },
                _g["&.".concat(switchClasses.checked)] = (_h = {
                        transform: "translateX(".concat(typography.pxToRem(SWITCH_DIMENSIONS.thumbSizePx + 4), ")")
                    },
                    _h["& + .".concat(switchClasses.track)] = {
                        opacity: 1,
                    },
                    _h),
                _g["&.".concat(switchClasses.disabled, ",&:hover,&:active")] = {
                    backgroundColor: 'transparent',
                },
                _g),
            thumb: {
                height: typography.pxToRem(SWITCH_DIMENSIONS.thumbSizePx),
                width: typography.pxToRem(SWITCH_DIMENSIONS.thumbSizePx),
                borderRadius: typography.pxToRem(SWITCH_DIMENSIONS.thumbSizePx),
            },
        },
    };
};
